import { render, staticRenderFns } from "./SummarizeConsumerReport.vue?vue&type=template&id=5337f243"
import script from "./SummarizeConsumerReport.vue?vue&type=script&lang=js"
export * from "./SummarizeConsumerReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports